export default __webpack_public_path__ + "static/media/leaf-right.e9fce577.png";